export default __webpack_public_path__ + "static/media/active-momentum-checkout-banner-web.7deb3c99.png";